// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/38a8628f31183ef3047d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"7706fa48f37038f4a36a","267":"b6e110c9f327dd082e02","268":"1e06207c843f51845482"}[chunkId] + ".chunk.js";
};